// Translations
import landing from '../views/landing/translations/tr'

// Translation: Reset (Turkish)
export default Object.freeze({
	name: 'Sıfırlama',
	views: { landing }
})
